class Device {
  constructor() {
    this.numpad = false
    this._powerstate = "on"
    this._softAp = false
  }
  _init = async () => {
    return true
  }
  properties = async () => {
    const properties = {
      mac: "12:34:56:78:90:12",
      ip: "0.0.0.0",
      serial: "1234567890",
      firmware: window.navigator.platform,
      software: this._browserDetect(),
      manufacturer: "Playroom",
      product: "PC",
      type: "universal"
    }

    const res = Object.keys(properties).every(key => {
      return properties[key] || false
    })

    return res && properties
  }
  baseUrl = async () => {
    return location.origin
  }
  getKeyMap = async () => {
    return [
      // Controllers
      [37, "left"],
      [38, "up"],
      [39, "right"],
      [40, "down"],
      [13, "enter"],
      [8, "back"],
      [27, "exit"],
      [175, "vol_up"],
      [174, "vol_down"],
      [173, "mute"],

      // Player Controller
      [-1, "play"],
      [-1, "pause"],
      [179, "toggle"],
      [178, "stop"],
      [176, "fw"],
      [177, "rw"],
      [-1, "prev"],
      [-1, "next"],

      // TV
      [33, "ch_up"],
      [34, "ch_down"],
      [-1, "tv"],
      [-1, "subtitle"],
      [-1, "list"],
      [-1, "epg"],

      // General
      [112, "info"],
      [-1, "settings"],
      [-1, "alarm-clock"],
      [-1, "sleep-timer"],
      [-1, "source"],
      [-1, "power"],
      [36, "home"],
      [36, "refresh"],

      [-1, "red"],
      [-1, "green"],
      [-1, "yellow"],
      [-1, "blue"],

      // Numpad
      [48, "numpad", 0],
      [49, "numpad", 1],
      [50, "numpad", 2],
      [51, "numpad", 3],
      [52, "numpad", 4],
      [53, "numpad", 5],
      [54, "numpad", 6],
      [55, "numpad", 7],
      [56, "numpad", 8],
      [57, "numpad", 9],

      // Applications
      [-1, "youtube"],
      [-1, "netflix"],
      [-1, "prime"],
      [-1, "spotify"],
      [-1, "browser"],
      [-1, "cast"],
      [-1, "movies"],
      [-1, "musics"],
      [-1, "usb"]
    ]
  }
  setName = async name => {
    if (!name) return false
    localStorage.setItem("deviceName", name)
    return true
  }
  getName = async () => {
    return localStorage.deviceName
  }

  /* Register Methods */
  registerKeys = async () => {
    return true
  }

  /* Volume Management */
  volume = async volume => {
    let promise = await _$.progress.create()

    if (typeof volume !== "number") {
      promise.resolve(__._hls.player.volume() * 100)
    } else {
      __._hls.player.volume(volume / 100)
      promise.resolve()
    }

    return promise.done
  }
  mute = async value => {
    if (["boolean", "number"].indexOf(typeof value) >= 0) {
      __._hls.player.muted(value ? true : false)
      return true
    }
    return __._hls.player.muted()
  }
  maxVolume = async () => {
    this.volume(__.device.maxVolume)
    __._hls.player.onvolumechange = async () => {
      const currentVolume = await this.volume()
      if (currentVolume > __.device.maxVolume) this.volume(__.device.maxVolume)
    }
    return true
  }

  /* Power Management */
  getPowerState = async () => {
    return this._powerstate
  }
  powerOn = async () => {
    this._powerstate = "on"

    __.platform.show()
    _$.handler.emit("power", "on")
    return true
  }
  standBy = async () => {
    this._powerstate = "standby"

    __.platform.hide()
    _$.handler.emit("power", "standby")
    return true
  }
  reboot = async () => {
    window.location.reload(true)
    return true
  }
  clearData = async () => {
    return true
  }
  async getSoftAP() {
    return {
      ssid: __.device.get("name"),
      password: __.device.generateSoftAPPassword(),
      status: this._softAp
    }
  }
  async enableSoftAP() {
    this._softAp = true
    return true
  }
  async disableSoftAP() {
    this._softAp = false
    return true
  }
  async isSoftAPEnabled() {
    return this._softAp
  }

  _browserDetect() {
    // Get the user-agent string
    let userAgentString = navigator.userAgent

    // Detect Chrome
    let chromeAgent = userAgentString.indexOf("Chrome") > -1

    // Detect Internet Explorer
    let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1

    // Detect Firefox
    let firefoxAgent = userAgentString.indexOf("Firefox") > -1

    // Detect Safari
    let safariAgent = userAgentString.indexOf("Safari") > -1

    // Discard Safari since it also matches Chrome
    if (chromeAgent && safariAgent) safariAgent = false

    // Detect Opera
    let operaAgent = userAgentString.indexOf("OP") > -1

    // Discard Chrome since it also matches Opera
    if (chromeAgent && operaAgent) chromeAgent = false

    if (chromeAgent) return "Chrome"
    else if (safariAgent) return "Safari"
    else if (operaAgent) return "Opera"
    else if (firefoxAgent) return "Firefox"
    else if (IExplorerAgent) return "MSIE"
    else return "Undefined"
  }
}

export default Device
